<script setup lang="ts">
  import { TRAINING_CONTROL_TYPE_LABELS, type TrainingType } from '@/entities/Training';

  const props = defineProps<{
    type: TrainingType;
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-type"
    class="flex flex-col gap-2 border-b border-gray-02 px-6 py-8"
  >
    <span class="text-xs font-semibold text-gray-07">Tipo de Treinamento</span>
    <span
      data-testid="training-control-type"
      class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
    >
      {{ TRAINING_CONTROL_TYPE_LABELS[props.type] }}
    </span>
  </section>
</template>
